import { render, staticRenderFns } from "./usdtmore.vue?vue&type=template&id=e45b1ed6&scoped=true"
import script from "./usdtmore.vue?vue&type=script&lang=js"
export * from "./usdtmore.vue?vue&type=script&lang=js"
import style0 from "./usdtmore.vue?vue&type=style&index=0&id=e45b1ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45b1ed6",
  null
  
)

export default component.exports